import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CommonService } from "@core/http/serviceIndex";
@Component({
  selector: "cancel-btn",
  template: `
    <button type="button" (click)="goBack()" class="btn btn-cancel">
      Cancel
    </button>
  `,
  styleUrls: ["./cancel-btn.component.css"],
})
export class CancelBtnComponent implements OnInit {
  @Input() newTab;
  @Input() isEvent;
  @Output() eventEmit: any = new EventEmitter<any>();

  constructor(private _cservice: CommonService) {}

  ngOnInit() {}

  goBack() {
    if (this.newTab) {
      window.close();
    } else if (this.isEvent) {
      this.eventEmit.emit();
    } else {
      this._cservice.goBackPrev();
    }
  }
}
